import { BaseSystemModel, Guid, RecursivePartial } from '@models/base';

export class WikiDocBase extends BaseSystemModel {
    _type = BaseSystemModel.Type.WikiDoc;

    orgId: Guid = '';
    projectId?: Guid;
    parentId?: Guid;
    name: string = '';
    description?: string;
    tagIds?: Guid[];
    version: number = 0;
    lastVersion: number = 0;
    lastDocumentDt?: Date;
    baseVersionId?: Guid;
    public?: boolean;
    childrenCount: number = 0;
    numId: number = 0;
    hasDraft?: boolean;
    hierarchy?: WikiDocBase[];
    fileIds?: Guid[];
    children?: WikiDocBase[];

    constructor(json?: RecursivePartial<WikiDocBase>) {
        super(json);
        this.parseWikiDocBase(json || {});
    }

    parse(json: RecursivePartial<WikiDocBase>): WikiDocBase {
        super.parse(json);
        this.parseWikiDocBase(json);
        return this;
    }

    private parseWikiDocBase(json: RecursivePartial<WikiDocBase>): void {
        WikiDocBase.assignFields(this, json, [
            'orgId',
            'projectId',
            'parentId',
            'name',
            'description',
            'tagIds',
            'version',
            'lastVersion',
            'public',
            'childrenCount',
            'numId',
            'hasDraft',
            'fileIds',
            'baseVersionId',
        ]);
        WikiDocBase.assignClassArrays(this, json, { children: WikiDocBase, hierarchy: WikiDocBase });
        WikiDocBase.assignDates(this, json, ['lastDocumentDt']);
        if (this.version === 0) {
            this.hasDraft = true;
        }
    }
}
